import { render } from "./sign-up-complete.vue?vue&type=template&id=02ab0cdc&ts=true"
import script from "./sign-up-complete.vue?vue&type=script&lang=ts"
export * from "./sign-up-complete.vue?vue&type=script&lang=ts"

import "./sign-up-complete.vue?vue&type=style&index=0&id=02ab0cdc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__